import { useQuery } from "@tanstack/react-query"
import { IssueReportTopicGet } from "../app/models/IssueReportTopic"
import { digitalManagerApi } from "../services/api"

export function useIssueReportTopics() {
  const { data: issueReportTopicsList = [], isLoading: isLoadingIssueReportTopics } =
    useQuery({
      queryKey: ["issueReportTopics"],
      queryFn: () =>
        digitalManagerApi
          .get<IssueReportTopicGet[]>(`/issueReportTopics`)
          .then((r) => r.data),
    })

  return {
    issueReportTopicsList,
    isLoadingIssueReportTopics,
  }
}
